<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>

                            <el-col :span="12" class="item">
                                <el-form-item label="商家名称" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入商家名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="地址" required prop="address">
                                    <el-input v-model="editForm.address" placeholder="请输入地址"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm('editForm')">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{'header': 1}, {'header': 2}],               // custom button values
        [{'align': ['']},{'align': ['center']}],
        ['image'],
    ]
    export default {
        name: 'Add',
        props: [],
        data() {
            return {

                editorOptionEdit: {
                    modules: {
                        toolbar: {
                            container: toolbarOptions,  // 工具栏
                            handlers: {
                                'image': function (value) {
                                    if (value) {
                                        //alert('自定义图片');
                                        document.querySelector('.el-btn-edit').click()
                                    } else {
                                        this.quill.format('image', false);
                                    }
                                }
                            }
                        }
                    }
                },
                idPhotoFileList:[],
                businessImgFileList:[],
                appendixFileList:[],
                imageUrl:'',

                loading: false,
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                serviceTypeValue:['正常营业','暂停营业','禁止营业'],
                closedCircleValue:['天','周','月','季度'],
                natureValue:['工商注册','社会组织','个体工商户'],
                publishRegionValue:['服务类','商品类'],

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),

                  name:'',
                  address:'',
                  businessCode:'',

                },

                zoneList:null,
                dialogImageUrl: '',
                dialogVisible: false,


              businessTypes:[
                {value:1,label:'家政服务商'},
                {value:2,label:'积分兑换商'},
                {value:3,label:'社区食堂商'}
              ],

              rules:{
                  phone:[
                      { required: true, message: '请输入手机号', trigger: 'blur' },
                      {
                          pattern: /^1[3456789]\d{9}$/,
                          message: '请输入正确的手机号'
                      },
                  ],
                  name:[
                      { required: true, message: '请输入商家名称', trigger: 'blur' },
                  ],
                  address:[
                      { required: true, message: '请输入地址', trigger: 'blur' },
                  ],


              },

            }
        },
        methods: {
            init(row){

                this.$refs.editForm.resetFields();

                this.editForm.name=row.name;
                this.editForm.address=row.address;
                this.editForm.businessCode=row.businessCode;

            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            handleIdPhotoRemove(file, fileList) {
                console.log(file, fileList);
                this.editForm.idPhoto = '';
            },
            handleidPhotoSuccess(res, file) {
                console.log(file)
                this.editForm.idPhoto = this.$imgUrl+res.data.path;
            },
            handleAppendixRemove(file, fileList) {
                console.log(file, fileList);
                this.editForm.appendix = '';
            },
            handlAppendixSuccess(res, file) {
                console.log(file)
                this.editForm.appendix = this.$imgUrl+res.data.path;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleBusinessImgRemove(file, fileList) {
                console.log(file, fileList);
                this.editForm.businessImg = '';
            },
            handleBusinessImgSuccess(res, file) {
                console.log(file)
                this.editForm.businessImg = this.$imgUrl+res.data.path;
            },
            handleBusinessImgPreview(file) {
                this.businessImageUrl = file.url;
                this.businessVisible = true;
            },
            edit_bf2(res,file) {

                console.log(file)
                let that = this;
                // 获取富文本组件实例
                let quill = that.$refs.myQuillEditor.quill;

                // 获取光标所在位置
                let length = quill.selection.savedRange.index;

                // 插入图片，res为服务器返回的图片链接地址
                quill.insertEmbed(length, 'image', that.$imgUrl+res.data.path);

                // 调整光标到最后
                quill.setSelection(length + 1);

            },


            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'warning', message: '请完善信息'});
                        return false;
                    }
                })
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Business/EditByGov",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'warning', message: response.data.message});
                        }
                    }
                )
            }

        }
    }
</script>

<style  lang="scss" scoped>

</style>
